




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { channellogout } from '@/api/login';
@Component({
    computed: mapState({ user: (state:any) => state.user }),
})
export default class Header extends Vue {
  private privateThis:any = this;

  // // 退出
  exit() {
      channellogout().then((res) => {
          if (res.data.status === 1) {
              this.$router.push({ path: '/login' });
              // window.location.reload()
              this.$store.commit('resetState');
              sessionStorage.clear();
          } else {
              this.privateThis.$Gtmessage.error(res.data.error_msg);
          }
      });
  }
}
